import { ICredentials } from "../types/ICredentials";
import { IHavePath } from "../types/IHavePath";

export interface ILogin extends ICredentials {}

export const LoginMeta: IHavePath = { path: "/login" };
